import { render, staticRenderFns } from "./yearServicepay.vue?vue&type=template&id=b01267e4&scoped=true"
import script from "./yearServicepay.vue?vue&type=script&lang=js"
export * from "./yearServicepay.vue?vue&type=script&lang=js"
import style0 from "./yearServicepay.vue?vue&type=style&index=0&id=b01267e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01267e4",
  null
  
)

export default component.exports